import React from 'react';

/**
 * Toggle enxuto — apenas o switch (sem título/ícone).
 * Reusa o CSS global .toggle-wrapper/.toggle-slider (toggleAntiClone.css).
 * Passe className="toggle-sm" para a versão compacta.
 */
export default function Toggle({ checked = false, onChange, id, className = '' }) {
    return (
        <label className={`toggle-wrapper ${className}`.trim()}>
            <input
                id={id}
                type="checkbox"
                checked={!!checked}
                onChange={(e) => onChange && onChange(e.target.checked)}
            />
            <span className="toggle-slider" />
        </label>
    );
}
